import { Card, Stack, Typography, Grid } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import Page from "../components/Page";

import FiltroEgresos from "../sections/@reporteador/FilltroEgresos";
import ReporteEgresosDetalle from "../sections/@reporteador/ReporteEgresos";
const ReporteEgresos = () => {
  const [datos, setDatos] = useState([]);
  const [title, setTitle] = useState("");
  return (
    <>
      <Page title="Reporteador">
        <Container maxWidth="xl">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Reporteador de Egresos
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <FiltroEgresos setDatos={setDatos} />
              </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <ReporteEgresosDetalle datos={datos} leyendas={title}/>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
};

export default ReporteEgresos;
